import Vue from 'vue'

export const state = {
    customer: null,
    account: null,
    billRun: null,
    signUpLogs: null,
    serviceBundleLogs: null,
    fallbackImage: false,
    releaseVersions: null,
    budgetBotInfo: null,
}

export default {
    state,
    mutations: {
        updateCustomer(state, customer) {
            state.customer = customer
        },
        updateAccount(state, account) {
            state.account = account
        },
        setBillRun(state, billRun) {
            state.billRun = billRun
        },
        setBudgetBotInfo(state, budgetBotInfo) {
            state.budgetBotInfo = budgetBotInfo
        },
        updateSignUpLogs(state, signUpLogs) {
            state.signUpLogs = Array.isArray(signUpLogs) ? signUpLogs.sort((a, b) => (b.LoggedAt > a.LoggedAt ? 1 : -1)) : undefined; // Sort newest > oldest
        },
        updateServiceBundleLogs(state, logs) {
            state.serviceBundleLogs = logs
        },
        updateFallbackImage(state, bool) {
            state.fallbackImage = bool
        },
        updateReleaseVersions(state, releaseVersions) {
            state.releaseVersions = releaseVersions
        },
    },
    actions: {
        setCustomer({ commit, dispatch, state }, reference) {
            //customer
            state.customer = null
            state.account = null
            state.fallbackImage = false

            dispatch('updateReleaseVersions')
            return Vue.prototype.$http
                .get("https://" + Vue.config.honeycomb.contractbot.domain + "/api/v1/Customers/customerReference/" + reference, {
                    withCredentials: true
                })
                .then(response => {
                    commit('updateCustomer', response.data)
                    dispatch('getAccount', response.data)
                    dispatch('getBudgetBotInfo', response.data)
                    commit('refreshTransfer')
                    commit('resetServiceBundleResults')
                    dispatch('refreshCustomerData')

                })
        },

        refreshCustomer({ commit, dispatch, state }) {
            dispatch('updateReleaseVersions')
            Vue.prototype.$http
                .get("https://" + Vue.config.honeycomb.contractbot.domain + "/api/v1/Customers/customerReference/" + state.customer.CustomerReference, {
                    withCredentials: true
                })
                .then(response => {
                    commit('updateCustomer', response.data)
                })
        },

        updateReleaseVersions({ commit }) {
            Vue.prototype.$http
                .get("https://" + Vue.config.honeycomb.releasebot.domain + `/api/v1/snapshots/${Vue.config.honeycomb.environment}/current`, {
                    withCredentials: true
                })
                .then(response => {
                    commit('updateReleaseVersions', response.data)
                }).catch(() => {
                    commit('updateReleaseVersions', null)
                })
        },

        refreshCustomerData({ dispatch, rootState }) {
            //contracts
            rootState.contracts.contracts = [];
            rootState.contracts.contract = null;
            rootState.contracts.mprnContracts = [];
            rootState.contracts.services = [];
            rootState.contracts.serviceBundles = [];
            rootState.contracts.serviceBundlesPrices = [];
            rootState.contracts.serviceBundleList = [];
            rootState.contracts.customerLevelPriortityServices = [];
            rootState.contracts.serviceLevelPriorityServices = [];
            rootState.contracts.gasServices = null;
            rootState.contracts.serviceToggle = null;
            rootState.contracts.elecServices = null;
            rootState.contracts.telecomServices = null;
            rootState.contracts.progress = null;
            rootState.contracts.contractIndex = [];
            rootState.contracts.activeSection = 'Contracts';
            rootState.contracts.breadcrumbItems = ['Contracts'];
            rootState.contracts.activeContract = null;
            rootState.contracts.activeBundle = null;
            rootState.contracts.activeService = null;
            rootState.contracts.activePSRSet = null;
            rootState.contracts.psrName = null;
            rootState.contracts.psrPassword = null;
            rootState.contracts.psrNotes = null;
            rootState.contracts.psrServices = [];
            rootState.contracts.editContractMode = false;
            rootState.contracts.editServiceMode = false;
            rootState.contracts.editConfigMode = false;
            rootState.contracts.editPSRSetMode = false;
            rootState.contracts.editPriorityServiceMode = false;

            //meters
            rootState.meters.metersList = [];
            rootState.meters.activeService = null;
            rootState.meters.activeMeter = null;
            rootState.meters.activeMeterInfo = null;
            rootState.meters.activeConfigInfo = null;
            rootState.meters.reading = null;
            rootState.meters.advances = [];
            // rootState.meters.isValid = true;
            // rootState.meters.override = false;
            rootState.meters.showExcludedReadings = false;
            rootState.meters.showOnlyCustomer = true;
            rootState.meters.meterSerialFilter = "All";

            //finance
            rootState.finances.invoiceItems = [];
            rootState.finances.invoiceGross = 0;
            rootState.finances.invoiceNet = 0;
            rootState.finances.vatTotals = [];
            rootState.finances.ledger = null;
            rootState.finances.agedDebt = null;
            rootState.finances.bankDetails = null;
            rootState.finances.ddOrganisationId = null;
            rootState.finances.reverseTransaction = null;
            rootState.finances.endBankAccount = null;
            rootState.finances.paymentLogs = null;
            rootState.finances.billLogs = null;
            rootState.finances.payments = [];
            rootState.finances.billOH = [];
            rootState.finances.collectionPayments = [];
            rootState.finances.runDetails = null;
            rootState.finances.billDetails = null;
            rootState.finances.chargeDetails = null;
            rootState.finances.usage = null;
            rootState.finances.bills = [];
            rootState.finances.billRuns = [];
            rootState.finances.charges = [];
            rootState.finances.salesTransactions = [];
            rootState.finances.writeOffAmount = null;
            rootState.finances.reversalAmount = null;
            rootState.finances.writeOffReason = null;
            rootState.finances.allSelectedForWriteOff = false;
            rootState.finances.selectedForWriteOff = [];
            rootState.finances.reversalReason = null;
            rootState.finances.allSelectedForReversal = false;
            rootState.finances.selectedForReversal = [];
            rootState.finances.fixedPayments = []
            rootState.finances.bacsCalendar = null
            rootState.finances.fixedPaymentEditMode = false
            rootState.finances.selectedBillsforBulkDelete = []

            dispatch('getContracts')
            dispatch('getBills')
            dispatch('getCharges')
            dispatch('getLedger')
            dispatch('getUsage')
            dispatch('getAgedDebt')
            dispatch('getBankDetails')
            dispatch('getFixedPayments')
            dispatch('getSalesTransactions')
        },
        async getSignUpLogs() {
            const url = `https://${Vue.config.honeycomb.logbot.domain}/api/v1/Messages/DesmLoader`
            
            let response = await Vue.prototype.$http.get(url, { withCredentials: true });
            return Array.isArray(response.data ) ? response.data .sort((a, b) => (b.LoggedAt > a.LoggedAt ? 1 : -1)) : undefined;
        },
        async getAruddProcessingLogs() {
            const url = `https://${Vue.config.honeycomb.logbot.domain}/api/v1/Messages/AruddProcessing`
            
            let response = await Vue.prototype.$http.get(url, { withCredentials: true });
            return Array.isArray(response.data ) ? response.data .sort((a, b) => (b.LoggedAt > a.LoggedAt ? 1 : -1)) : undefined;
        },
        getServiceBundleLogs({ commit }) {
            Vue.prototype.$http
                .get("https://" + Vue.config.honeycomb.logbot.domain + "/api/v1/Messages/ServiceBundleUpdate", {
                    withCredentials: true
                })
                .then(response => {
                    commit('updateServiceBundleLogs', response.data);
                })
        },
        getAccount({ commit }, customer) {
            Vue.prototype.$http
                .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/Accounts/" + customer.AccountId, {
                    withCredentials: true
                })
                .then(response => {
                    commit('updateAccount', response.data);
                })
        },
        getBudgetBotInfo({commit}, customer){
            Vue.prototype.$http
                .get("https://" + Vue.config.honeycomb.budgetbot.domain + "/api/v1/plans/?customerid=" + customer.Id, {
                    withCredentials: true
                })
                .then(response => {
                    commit('setBudgetBotInfo', response.data.Records);
                })
        }
    },
}